<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div [ngClass]="{ zonaoculta: loading === true }">
  <app-buttons
    (save)="submit()"
    (close)="closePanel()"
    (discard)="discard()"
    [buttonsWrap]="'panel'"
    [modificar]="modificar"
  ></app-buttons>

  <div class="editor-registro">
    <div class="divForm">
      <form [formGroup]="editRegistroForm" (ngSubmit)="submit()">
        <div class="form-group">
          <mat-form-field appearance="outline">
            <mat-label>{{ translation?.Codigo || 'Código' }}</mat-label>
            <input matInput formControlName="Clave" maxlength="50" (input)="onInputCaracteresProhibidos($event, 'Clave')" />
            <mat-error *ngIf="validateFields('Clave')">
              {{ getErrorMessage("Clave") }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>{{ translation?.Nombre || 'Nombre' }}</mat-label>
            <input matInput formControlName="Nombre" maxlength="50" (input)="onInputCaracteresProhibidos($event, 'Nombre')" />
            <mat-error *ngIf="validateFields('Nombre')">
              {{ getErrorMessage("Nombre") }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ translation?.Descripcion || 'Descripción' }}</mat-label>
            <textarea matInput formControlName="UrlCentro" rows="3" maxlength="255" (input)="onInputCaracteresProhibidos($event, 'UrlCentro')"></textarea>
            <mat-hint align="end">
              <span [ngClass]="getDescripcionCounterClass()">{{ (editRegistroForm?.get('UrlCentro')?.value?.length || 0) }}/255</span>
            </mat-hint>
            <mat-error *ngIf="validateFields('UrlCentro')">
              {{ getErrorMessage("UrlCentro") }}
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
</div>
